function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiConstants from 'invision-core/src/api/constants';
import { ThunkHelper } from 'invision-core';
import { GENERAL_STATUSES } from '../../components/shared/constants/general.status.constants';
export var SET_SELECTED_COUPON_REDEMPTION_CODE = 'SET_SELECTED_COUPON_REDEMPTION_CODE';
export var setSelectedCouponRedemptionCode = function setSelectedCouponRedemptionCode(payload) {
  return {
    type: SET_SELECTED_COUPON_REDEMPTION_CODE,
    payload: payload
  };
};
export var REMOVE_COUPON_REDEMPTION_CODE = {
  BEGIN: 'REMOVE_COUPON_REDEMPTION_CODE_BEGIN',
  SUCCESS: 'REMOVE_COUPON_REDEMPTION_CODE_SUCCESS',
  FAILURE: 'REMOVE_COUPON_REDEMPTION_CODE_FAILURE'
};
var REMOVE_COUPON_REDEMPTION_CODE_EVENTS = [REMOVE_COUPON_REDEMPTION_CODE.BEGIN, REMOVE_COUPON_REDEMPTION_CODE.SUCCESS, REMOVE_COUPON_REDEMPTION_CODE.FAILURE];
var removeCouponRedemptionCodePromise = function removeCouponRedemptionCodePromise(dispatch, couponRedemptionCodeId, removeReasonId) {
  return ThunkHelper(dispatch, REMOVE_COUPON_REDEMPTION_CODE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateRedemptionCode',
    data: {
      RedemptionCodeId: couponRedemptionCodeId,
      RedemptionCodeRemoveReason: removeReasonId,
      RedemptionCodeStatus: GENERAL_STATUSES.REMOVED
    }
  });
};
export var removeCouponRedemptionCode = function removeCouponRedemptionCode(couponRedemptionCodeId, removeReasonId) {
  return function (dispatch) {
    return removeCouponRedemptionCodePromise(dispatch, couponRedemptionCodeId, removeReasonId);
  };
};
export var UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION = {
  BEGIN: 'UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION_BEGIN',
  SUCCESS: 'UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION_SUCCESS',
  FAILURE: 'UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION_FAILURE'
};
var UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION_EVENTS = [UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION.BEGIN, UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION.SUCCESS, UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION.FAILURE];
var updateCouponRedemptionCodeExpirationPromise = function updateCouponRedemptionCodeExpirationPromise(dispatch, couponRedemptionCodeId, date, redemptionCodeStatus) {
  return ThunkHelper(dispatch, UPDATE_COUPON_REDEMPTION_CODE_EXPIRATION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateRedemptionCode',
    data: {
      RedemptionCodeId: couponRedemptionCodeId,
      RedemptionCodeExpiration: date,
      RedemptionCodeStatus: redemptionCodeStatus
    }
  });
};
export var updateCouponRedemptionCodeExpiration = function updateCouponRedemptionCodeExpiration(couponRedemptionCodeId, date, redemptionCodeStatus) {
  return function (dispatch) {
    return updateCouponRedemptionCodeExpirationPromise(dispatch, couponRedemptionCodeId, date, redemptionCodeStatus);
  };
};
export var SET_SELECTED_REASON_ID = 'SET_SELECTED_REASON_ID';
export var setSelectedReasonId = function setSelectedReasonId(payload) {
  return {
    type: SET_SELECTED_REASON_ID,
    payload: payload
  };
};
export var SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_CONSTANTS = {
  BEGIN: 'SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_BEGIN',
  SUCCESS: 'SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_SUCCESS',
  FAILURE: 'SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_FAILURE'
};
var SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_EVENTS = [SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_CONSTANTS.BEGIN, SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_CONSTANTS.SUCCESS, SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_CONSTANTS.FAILURE];
var searchCouponDetailsCouponRedemptionsPromise = function searchCouponDetailsCouponRedemptionsPromise(dispatch, customerId) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var languageHeader = arguments.length > 3 ? arguments[3] : undefined;
  var data = {
    CouponRedemptionCodeId: filter.couponRedemptionCodeId,
    End: filter.endDate,
    PageSize: filter.pageSize,
    PageNumber: filter.pageNumber,
    Start: filter.startDate
  };
  return ThunkHelper(dispatch, SEARCH_COUPON_DETAILS_COUPON_REDEMPTIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchCouponRedemptions',
    data: data,
    headers: _defineProperty(_defineProperty({}, ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, languageHeader), ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var searchCouponDetailsCouponRedemptions = function searchCouponDetailsCouponRedemptions(customerId, filter, languageHeader) {
  return function (dispatch) {
    return searchCouponDetailsCouponRedemptionsPromise(dispatch, customerId, filter, languageHeader);
  };
};
export var SET_REDEMPTION_CODE_REDEMPTIONS_CURRENT_PAGE = 'SET_REDEMPTION_CODE_REDEMPTIONS_CURRENT_PAGE';
export var setRedemptionCodeRedemptionsCurrentPage = function setRedemptionCodeRedemptionsCurrentPage(page) {
  return {
    type: SET_REDEMPTION_CODE_REDEMPTIONS_CURRENT_PAGE,
    payload: page
  };
};
export var SET_REDMEPTION_CODE_REDEMPTIONS_DATE_END_FILTER = 'SET_REDMEPTION_CODE_REDEMPTIONS_DATE_END_FILTER';
export var setRedemptionCodeRedemptionsDateEndFilter = function setRedemptionCodeRedemptionsDateEndFilter(date) {
  return {
    type: SET_REDMEPTION_CODE_REDEMPTIONS_DATE_END_FILTER,
    payload: date
  };
};
export var SET_REDMEPTION_CODE_REDEMPTIONS_DATE_START_FILTER = 'SET_REDMEPTION_CODE_REDEMPTIONS_DATE_START_FILTER';
export var setRedemptionCodeRedemptionsDateStartFilter = function setRedemptionCodeRedemptionsDateStartFilter(date) {
  return {
    type: SET_REDMEPTION_CODE_REDEMPTIONS_DATE_START_FILTER,
    payload: date
  };
};
export var SET_REDEMPTION_COUPONS_PAGE_SIZE_PREFERENCE = 'SET_REDEMPTION_COUPONS_PAGE_SIZE_PREFERENCE';
export var setRedemptionCodeRedemptionsPageSizePreference = function setRedemptionCodeRedemptionsPageSizePreference(pageSize) {
  return {
    type: SET_REDEMPTION_COUPONS_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};